import { useEffect, useState } from "react";

const useNetworkStatus = () => {
	const [status, setStatus] = useState<"loading" | "offline" | "online">("online");

	const updateNetworkStatus = () => {
		setStatus(navigator.onLine ? "online" : "offline");
	};

	useEffect(() => {
		window.addEventListener("load", updateNetworkStatus);
		window.addEventListener("online", updateNetworkStatus);
		window.addEventListener("offline", updateNetworkStatus);

		return () => {
			window.removeEventListener("load", updateNetworkStatus);
			window.removeEventListener("online", updateNetworkStatus);
			window.removeEventListener("offline", updateNetworkStatus);
		};
	}, []);

	return { status };
};

export default useNetworkStatus;
